import { Endpoint } from "@rest-hooks/endpoint";
import { BaseResource } from "./BaseResource";
export class AdditionalTermsResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.guid = undefined;
        this.term = "";
        this.appliesTo = undefined;
        this.addedAutomatically = undefined;
        this.readOnly = undefined;
    }
    pk(parent, key) {
        return this.guid ?? "";
    }
}
AdditionalTermsResource.urlRoot = "/api/applications/{applicationNumber}/additional-terms";
const fetchAdditionalTermSettings = (data) => fetch(`/api/applications/${data.applicationNumber}/additional-terms/settings`).then(res => {
    if (res.ok)
        return res.json();
    return [];
});
export const AdditionalTermSettingsEndpoint = new Endpoint(fetchAdditionalTermSettings, {});
//# sourceMappingURL=AdditionalTermsResource.js.map